import Icon from '../components/Icon.vue'

Icon.register({
  republican: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M544 192C544 103.6 472.4 32 384 32H160C71.6 32 0 103.6 0 192V256H544V192zM176.3 170.4L156.5 189.7 161.2 217C162 221.9 156.9 225.6 152.5 223.3L128 210.4 103.5 223.3C99.2 225.6 94 221.9 94.8 217L99.5 189.7 79.7 170.4C76.1 166.9 78.1 160.9 83 160.2L110.4 156.2 122.6 131.4C124.8 126.9 131.2 127 133.3 131.4L145.5 156.2 172.9 160.2C177.9 160.9 179.8 166.9 176.3 170.4zM320.3 170.4L300.5 189.7 305.2 217C306 221.9 300.9 225.6 296.5 223.3L272 210.4 247.5 223.3C243.2 225.6 238 221.9 238.8 217L243.5 189.7 223.7 170.4C220.1 166.9 222.1 160.9 227 160.2L254.4 156.2 266.6 131.4C268.8 126.9 275.2 127 277.3 131.4L289.5 156.2 316.9 160.2C321.9 160.9 323.8 166.9 320.3 170.4zM464.3 170.4L444.5 189.7 449.2 217C450 221.9 444.9 225.6 440.5 223.3L416 210.4 391.5 223.3C387.2 225.6 382 221.9 382.8 217L387.5 189.7 367.7 170.4C364.1 166.9 366.1 160.9 371 160.2L398.4 156.2 410.6 131.4C412.8 126.9 419.2 127 421.3 131.4L433.5 156.2 460.9 160.2C465.9 160.9 467.8 166.9 464.3 170.4zM624 320H592C583.2 320 576 327.2 576 336V400C576 408.8 568.8 416 560 416S544 408.8 544 400V288H0V464C0 472.8 7.2 480 16 480H112C120.8 480 128 472.8 128 464V384H320V464C320 472.8 327.2 480 336 480H432C440.8 480 448 472.8 448 464V352H480V395.3C480 437.1 510 475.4 551.6 479.6 599.4 484.5 640 446.9 640 400V336C640 327.2 632.8 320 624 320z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/republican.js
// module id = a8rp
// module chunks = 144